import { default as app } from "../app/routes.js";

export default [...app];
